export default __webpack_public_path__ + "static/media/P204.3.2caf3e59.mp3";